import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoDialogComponent } from './video-dialog.component';



@NgModule({
  declarations: [
    VideoDialogComponent
  ],
  imports: [
    CommonModule
  ]
})
export class VideoDialogModule { }
